// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"8070e465","635":"f32e923a"}[chunkId] + ".chunk.js";
};